import { fetchDataUrl } from "./images";

const FONT_CSS = "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;600;700;800&family=Outfit:wght@700;800;900&display=swap";
let fontCss = null;

const embedFonts = () => {
  if (!fontCss) {
    fontCss = (async () => {
      let css = await (await fetch(FONT_CSS)).text();
      const urls = [...new Set([...css.matchAll(/url\((https:[^)]+)\)/g)].map((m) => m[1]))];
      const datas = await Promise.all(urls.map((u) => fetchDataUrl(u)));
      urls.forEach((u, i) => { css = css.split(u).join(datas[i]); });
      return css;
    })().catch(() => { fontCss = null; return ""; });
  }
  return fontCss;
};

// Renders the live SVG (minus editing helpers & guides) to a PNG blob.
// Burns a tiled diagonal watermark into the pixels so preview downloads can't be printed as finals.
export const drawWatermark = (ctx, w, h, { div = 13, alpha = 1 } = {}) => {
  const size = Math.round(w / div);
  ctx.save();
  ctx.globalCompositeOperation = "source-atop";
  ctx.globalAlpha = alpha;
  ctx.translate(w / 2, h / 2);
  ctx.rotate(-Math.PI / 5);
  ctx.font = `900 ${size}px Outfit, sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.lineWidth = Math.max(1, size / 18);
  const text = "sportsshields.ie · PREVIEW";
  const stepY = size * 2.4, span = Math.hypot(w, h);
  for (let y = -span / 2, row = 0; y < span / 2; y += stepY, row++) {
    for (let x = -span / 2 + (row % 2) * size * 7.5; x < span / 2; x += size * 15) {
      ctx.strokeStyle = "rgba(15,23,42,.35)";
      ctx.fillStyle = "rgba(255,255,255,.38)";
      ctx.strokeText(text, x, y);
      ctx.fillText(text, x, y);
    }
  }
  ctx.restore();
};

// watermark=true for customer-facing downloads; print artwork passes watermark=false.
export async function svgToPng(svg, { scale = 2, type = "image/png", quality, watermark = true } = {}) {
  const clone = svg.cloneNode(true);
  clone.querySelectorAll("[data-export-hide]").forEach((n) => n.remove());
  await Promise.all([...clone.querySelectorAll("image")].filter((n) => n.getAttribute("href")?.startsWith("blob:")).map(async (n) => {
    const b = await (await fetch(n.getAttribute("href"))).blob();
    n.setAttribute("href", await new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(b); }));
  }));
  const vb = svg.viewBox.baseVal;
  const w = Math.round(vb.width * scale), h = Math.round(vb.height * scale);
  clone.setAttribute("width", w);
  clone.setAttribute("height", h);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const style = document.createElementNS("http://www.w3.org/2000/svg", "style");
  style.textContent = await embedFonts();
  clone.insertBefore(style, clone.firstChild);
  const src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(clone));
  const img = new Image();
  await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = src; });
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (type === "image/jpeg") { ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, w, h); }
  ctx.drawImage(img, 0, 0, w, h);
  if (watermark) drawWatermark(ctx, w, h);
  return new Promise((res) => canvas.toBlob(res, type, quality));
}

export const downloadBlob = (blob, filename) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
};

export const exportPng = async (svg, filename) => downloadBlob(await svgToPng(svg), filename);
